module.exports = __webpack_public_path__ + "static/media/blacklogo.cbf70d01.png";